import { stringify } from 'query-string';
const { REACT_APP_STRIPE_CLIENT_ID: stripeClientId } = process.env;

export default function getStripeConnectUrl(stateOverride) {
  let state = '';
  try {
    state = stateOverride || window.top.location.pathname + window.top.location.search;
  } catch (err) {
    // no-op
  }

  const qs = stringify({
    redirect_uri: window.location.origin + '/dashboard/seller/connect-stripe',
    response_type: 'code',
    client_id: stripeClientId,
    scope: 'read_write',
    state,
  });

  return `https://connect.stripe.com/oauth/authorize?${qs}`;
}
